import { render, staticRenderFns } from "./GestionePartProgram.vue?vue&type=template&id=53b904b1&"
import script from "./GestionePartProgram.vue?vue&type=script&lang=js&"
export * from "./GestionePartProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports